export const apiIDP = {
    GET_TOKEN: "/api/idp/sso/auth/token",
    GET_PROFILE: "/api/idp/third-party/userinfo",
};
